const PER_PAGE = 9;
let page = 0;

// news archvive block pagination
export const codeNews = () => {
  // on view more click, show next posts up to the per page limit
  $('.code-news .posts-pagination > .button').on('click', function () {
    $('.code-news .wp-block-post.hidden')
      .slice(0, PER_PAGE)
      .removeClass('hidden');

    const hasMorePosts = $('.code-news .wp-block-post.hidden').length > 0;

    $('.code-news .posts-pagination').toggleClass('hidden', !hasMorePosts);

    page++;
  });
};
